import { create } from 'zustand';

interface LocationData {
  as: string;
  city: string;
  country: string;
  countryCode: string;
  isp: string;
  lat: number;
  lon: number;
  org: string;
  query: string;
  region: string;
  regionName: string;
  status: string;
  timezone: string;
  zip: string;
}

interface UserLocationStore {
  location: LocationData | null;
  isLoading: boolean;
  error: string | null;
  setLocation: (location: LocationData) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearLocation: () => void;
}

export const useUserLocationStore = create<UserLocationStore>((set) => ({
  location: null,
  isLoading: false,
  error: null,
  setLocation: (location) => set({ location, error: null }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error, isLoading: false }),
  clearLocation: () => set({ location: null, error: null, isLoading: false }),
}));